import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

import { ORDER_HISTORY_URI } from 'constants/routes-constants';

import { Loading } from 'components/Loading';
import { OrderHistoryTable } from './OrderHistoryTable';

import { TotemButton } from 'ui/Button';
import { TotemFragmentFragment as Totem, useGetArchivedOrdersQuery } from 'data/__generated__';
import { DashboardOrderHistoryProps } from 'pages/Totem/TotemDashboard/TotemDashboard.types';

/**
 * Displays 3 first ARCHIVED orders
 */
export interface OrdersSmallHistoryProps extends Omit<DashboardOrderHistoryProps, 'currentTotem'> {
    totemId: Totem['_id'] | string;
}
export const OrdersSmallHistory = ({ baseUrl, ordersOfTotem, totemId }: OrdersSmallHistoryProps) => {
    const {
        loading: archivedOrdersLoading,
        error: archivedOrdersError,
        data: archivedOrdersData,
    } = useGetArchivedOrdersQuery({
        variables: { offset: 0, totemId },
        skip: !totemId,
    });
    if (archivedOrdersError) {
        throw new Error(archivedOrdersError.message);
    }
    if (archivedOrdersLoading || !totemId) {
        return <Loading relative={true} containerHeight="125px" imageSize={100} />;
    }
    const {
        archivedOrders: { archivedOrders },
    } = archivedOrdersData ?? { archivedOrders: { archivedOrders: [] } };

    const INITIAL_NB_ORDERS_TO_SHOW = 3;

    // Même remarque que dans `OrderHistory` : l'ordre (date de livraison décroissante) est celui du serveur,
    // donc les `INITIAL_NB_ORDERS_TO_SHOW` premières sont bien les plus récentes.
    const ordersToShow = archivedOrders?.filter((order) => order);

    return (
        <>
            {ordersToShow.length ? (
                <>
                    <OrderHistoryTable
                        ordersToShow={ordersToShow}
                        nbOrderToShow={INITIAL_NB_ORDERS_TO_SHOW}
                        ordersOfTotem={ordersOfTotem}
                        baseUrl={baseUrl}
                    />
                    <TotemButton
                        as={Link}
                        $type="secondary"
                        $alignSelf="center"
                        $fontSize="1em"
                        to={`${baseUrl}/${ORDER_HISTORY_URI}`}
                        data-test="see-complete-order-history"
                    >
                        Voir l'historique complet
                    </TotemButton>
                </>
            ) : (
                <ScheduleText>Une fois complétées, vos commandes apparaîtront ici !</ScheduleText>
            )}
        </>
    );
};

const ScheduleText = styled.div`
    font-size: 18px;
`;
